import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ANALYTICS_CHANNEL } from '../../../../../utils/analytics';
var createTrackRelatedLinksLoadedEventPayload = function createTrackRelatedLinksLoadedEventPayload(_ref) {
  var relatedLinksCount = _ref.relatedLinksCount;
  return {
    action: 'loaded',
    actionSubject: 'relatedLinks',
    eventType: 'track',
    attributes: {
      relatedLinksCount: relatedLinksCount
    }
  };
};
export var fireRelatedLinksLoadedEvent = function fireRelatedLinksLoadedEvent(createAnalyticsEvent) {
  return function (attributes) {
    var payload = createTrackRelatedLinksLoadedEventPayload(attributes);
    if (payload) {
      createAnalyticsEvent(_objectSpread({}, payload)).fire(ANALYTICS_CHANNEL);
    }
  };
};